import { allRegistries } from "@/content";
import type { NavMeta } from "./types";

export interface ContentNavItem {
  label: string;
  href: string;
  group: string;
  order: number;
}

const DEFAULT_GROUP = "features";
const DEFAULT_ORDER = 100;

// Collects nav items from every content registry. Only pages that declared a
// `nav` block are included, so this is opt-in and safe to render anywhere —
// an empty result means "render nothing". Sorted by order, then label.
export function getContentNavItems(group?: string): ContentNavItem[] {
  const items: ContentNavItem[] = [];

  for (const registry of allRegistries) {
    for (const page of registry.all()) {
      const nav: NavMeta | undefined = page.nav;
      if (!nav) continue;

      const itemGroup = nav.group || DEFAULT_GROUP;
      if (group && itemGroup !== group) continue;

      items.push({
        label: nav.label,
        href: registry.urlFor(page),
        group: itemGroup,
        order: nav.order ?? DEFAULT_ORDER,
      });
    }
  }

  return items.sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));
}
